<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
        </div>
      </div>
      <el-table v-loading="listLoading" :data="tableData.data" style="width: 100%" size="small" highlight-current-row>
        <el-table-column prop="alipay_account_black_id" label="ID" min-width="60"/>
        <el-table-column prop="user.phone" label="用户手机号" min-width="120"/>
        <el-table-column prop="alipay_account" label="支付宝账号" min-width="120"/>
        <el-table-column prop="alipay_name" label="出款支付宝姓名" min-width="120"/>
        <el-table-column label="操作" min-width="130" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDelete(scope.row.alipay_account_black_id, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination :page-sizes="[20, 40, 60, 80]" :page-size="userFrom.limit" :current-page="userFrom.page"
                       layout="total, sizes, prev, pager, next, jumper" :total="tableData.total"
                       @size-change="handleSizeChange" @current-change="pageChange"/>
      </div>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {
  changeNowMoneyApi,
  userBalanceCardListApi
} from '@/api/user'
import {
  alipayBalanceCardListApi,
  alipayBalanceLstApi,
  alipayBlackDeleteApi,
  alipayBlackLstApi,
  changeAlipayBalanceApi
} from "@/api/accounts";
import {recoveryOrderDeleteApi} from "@/api/recovery";

export default {
  name: 'AlipayBlackList',
  components: {
  },
  data() {
    return {
      moren: require("@/assets/images/f.png"),
      timeVal: [],
      collapse: false,
      visibleDetail: false,
      dialogVisible: false,
      maxCols: 3,
      isShowSend: true,
      visible: false,
      loading: false,
      user_type: '',
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      multipleSelection: [],
      ruleForm: [],
      ids: '',
      wechatIds: '',
      uid: '',
      labelPosition: 'right',
      userProps: {
        children: 'children',
        label: 'name',
        value: 'name'
      },
      formData: {'spread_image': ''},
      userFrom: {
        page: 1,
        limit: 20,
      },
      address: [],
      grid: {
        xl: 8,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid2: {
        xl: 18,
        lg: 16,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid3: {
        xl: 8,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      addresData: [],
      groupList: [],
      labelLists: [],
      chkName: '',
      checkedPage: [],
      allCheck: false,
      cancel_time: null,
      cardLists: [],

    }
  },
  mounted() {
    this.getList('')
  },
  methods: {
    // 列表
    getList(num) {
      this.listLoading = true
      this.userFrom.page = num ? num : this.userFrom.page;
      this.userFrom.is_authority = 0
      alipayBlackLstApi(this.userFrom).then(res => {
        this.tableData.data = res.data.list
        this.tableData.total = res.data.count
        this.listLoading = false
      }).catch(res => {
        this.listLoading = false
        this.$message.error(res.message)
      })
    },
    // 删除
    handleDelete(id, idx) {
      this.$modalSure().then(() => {
        alipayBlackDeleteApi(id).then(({message}) => {
          this.$message.success(message)
          this.getList()
        }).catch(({message}) => {
          this.$message.error(message)
        })
      })
    },
    pageChange(page) {
      this.userFrom.page = page
      this.getList('')
    },
    handleSizeChange(val) {
      this.userFrom.limit = val
      this.getList('')
    },
    openVisibleMoney(){
      this.$modalForm(changeAlipayBalanceApi()).then(() => this.getList(''))
    }
  }
}
</script>

<style lang="scss" scoped>
.check {
  color: #00a2d4;
}

.selWidth {
  // width: 100% !important;
}

.dia {
  /deep/ .el-dialog__body {
    height: 700px !important;
  }
}

.text-right {
  text-align: right;
}

.container {
  min-width: 821px;

  /deep/ .el-form-item {
    width: 100%;
  }

  /deep/ .el-form-item__content {
    width: 72%;
  }
}

.vipName {
  color: #dab176
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  font-size: 12px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 33.33%;
}

/deep/ [type=reset],
[type=submit],
button,
html [type=button] {
  -webkit-appearance: none !important;
}
</style>
